import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle, faFont, faSquare} from "@fortawesome/free-solid-svg-icons";

export const highlight = <FontAwesomeIcon icon={faFont} mask={faSquare} transform="shrink-6" />;
export const highlightColor = color => (<span className="fa-layers fa-fw">
  <FontAwesomeIcon icon={faCircle} transform="grow-8" style={{color}} />
  <FontAwesomeIcon icon={faFont} transform="shrink-4" />
</span>);
